import { Component, OnInit } from '@angular/core';
import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { WidenService } from '@services/widen.service';
import { ArticleHubContent } from '@marketing/insights/insights.interface';
import { Observable } from 'rxjs';
import { ResponsiveService } from '@frk/eds-components';
import { LocalLinkService } from '@services/local-link.service';

/**
 * The Article Hub component can be used to display hub page for article
 *
 * Selector: `ft-article-hub`
 *
 * Exported as: `ArticleHubComponent`
 */
@Component({
  selector: 'ft-article-hub',
  templateUrl: './article-hub.component.html',
})
export class ArticleHubComponent
  extends AbstractBaseComponent
  implements OnInit {
  articleHubInfo: ArticleHubContent;
  translationLabels: any;
  isMobile$: Observable<boolean>;

  /**
   * SIM logo resource bundle object
   */
  simLogoResourceBundle: object;

  /**
   * Constructor
   */
  constructor(
    private widenService: WidenService,
    private locallinkService: LocalLinkService,
    responsiveService: ResponsiveService
  ) {
    super();
    this.isMobile$ = responsiveService.isMobile$();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.setBreadcrumbItems();
    this.translationLabels = this.component?.getModels()[
      'ft.core.insightsLibrary'
    ];
    this.simLogoResourceBundle = this.component?.getModels()[
      'ft.core.sim-logos'
    ];
    this.articleHubInfo = this.document?.getData<ArticleHubContent>();
    this.articleHubInfo.summary.value = this.locallinkService.getLocalizeLinks(
      this.articleHubInfo.summary.value
    );
    if (this.articleHubInfo?.logo) {
      this.articleHubInfo.imageSrc = this.widenService.getWidenImageVariantUrl(
        this.widenService.getWidenAssetUrl(
          this.articleHubInfo.logo.widenDocument
        ),
        'original',
        'webp'
      );
    }
  }
}
